import { inject } from '@angular/core';
import { TuiDialogService } from '@taiga-ui/core';
import { PolymorpheusComponent } from '@taiga-ui/polymorpheus';
import { DynamicViewDefaultsDialogComponent } from './dynamic-view-defaults-dialog.component';

export function injectDynamicViewDefaultsDialog() {
  const tuiDialogService = inject(TuiDialogService);

  return () =>
    tuiDialogService.open<void>(
      new PolymorpheusComponent(DynamicViewDefaultsDialogComponent),
      {
        dismissible: true,
        size: 'l'
      }
    );
}
